<template>
  <div class="sz-sensors">
    <el-row>
      <el-col :span="8" v-for="sensor in sensors" :key="sensor.id">
        <div class="item">
          <div class="item-name">{{ sensor.name }}</div>
          <div class="item-value">
            {{ getValue(sensor) }}
            <span>{{ getUnit(sensor.o_unit) }}</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Col, Row } from "element-ui";
import { toFixed, getUnit } from "../utils";

export default {
  name: "szSensors",
  components: { ElCol: Col, ElRow: Row },
  props: {
    sensors: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getValue(sensor) {
      return toFixed(sensor.o_realtime?.value, sensor.o_unit);
    },
    getUnit(t) {
      return getUnit(t);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../theme.less";
.sz-sensors {
  padding: 15px 0;
}
.item {
  margin-bottom: 15px;
  &-name {
    color: #dcdcdc;
    font-size: 14px;
  }
  &-value {
    font-weight: bold;
    margin-top: 6px;
    font-size: 20px;
    color: @text-primary;
    text-shadow: 1px 1px 1px #0c1d46;
    font-family: DINCloud;
    span {
      font-size: 14px;
      color: #c4d1cc;
      font-family: "微软雅黑 Light";
      font-weight: normal;
      margin-left: 4px;
    }
  }
}
</style>
